import React from "react";
import { SvgIcon, SvgIconProps } from '@mui/material';

const UncheckIcon= (props: SvgIconProps) => {
	const { htmlColor } = props
	return <SvgIcon {...props} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="6" cy="6.5" r="5" fill="white" stroke={htmlColor} strokeWidth="2"/>
	</SvgIcon>
}

export default UncheckIcon;
